import { render, staticRenderFns } from "./KpiScenep.vue?vue&type=template&id=1450d935&scoped=true&"
import script from "./KpiScenep.vue?vue&type=script&lang=js&"
export * from "./KpiScenep.vue?vue&type=script&lang=js&"
import style0 from "./KpiScenep.vue?vue&type=style&index=0&id=1450d935&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1450d935",
  null
  
)

export default component.exports